import { render } from "./WCFavoriteButton.vue?vue&type=template&id=1e47301e&scoped=true"
import script from "./WCFavoriteButton.vue?vue&type=script&lang=js"
export * from "./WCFavoriteButton.vue?vue&type=script&lang=js"

import "./WCFavoriteButton.vue?vue&type=style&index=0&id=1e47301e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e47301e"]])

export default __exports__